function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
  id: "d"
}, /*#__PURE__*/React.createElement("g", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0v1h.5z",
  transform: "rotate(18 3.157 -.5)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a",
  transform: "scale(-1 1)"
})), /*#__PURE__*/React.createElement("g", {
  id: "c"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b",
  transform: "rotate(72)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b",
  transform: "rotate(144)"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c",
  transform: "scale(-1 1)"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#039",
  d: "M0 0h810v540H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "#fc0",
  transform: "matrix(30 0 0 30 405 270)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d",
  y: -6
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d",
  y: 6
}), /*#__PURE__*/React.createElement("g", {
  id: "e"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d",
  x: -6
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d",
  transform: "rotate(-144 -2.344 -2.11)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d",
  transform: "rotate(144 -2.11 -2.344)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d",
  transform: "rotate(72 -4.663 -2.076)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d",
  transform: "rotate(72 -5.076 .534)"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#e",
  transform: "scale(-1 1)"
}));

var SvgEuropeFlagIcon = function SvgEuropeFlagIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 810 540",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEuropeFlagIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/europe-flag-icon.93555e17.svg";
export { ForwardRef as ReactComponent };